import { Link } from 'react-router-dom';
import Donation from '../Donation';
import LiveRadio from '../LiveRadio';
import Navgation from '../Navigation';
import './style.scss';

function Header() {
    return (
        <header className="Header">
            <div className="header-content container-wide">
                <div className="header-item header-first">
                    <img src="/header_krem.svg" className="header-bg" />
                    <Link to="/" className="home-link">
                        <img src="/nor_logo.svg" />
                    </Link>
                </div>
                <div className="header-item header-second">
                    <img src="/header_black.svg" className="header-bg" />
                    <LiveRadio />
                </div>
                <div className="header-item header-third">
                    <img src="/header_red.svg" className="header-bg" />
                    <Donation />
                </div>
            </div>
            <Navgation />
        </header>
    );
}

export default Header;
